import { Loader } from "@googlemaps/js-api-loader";

const social = {
    init() {
        const loader = new Loader({
            apiKey: gmap_api_key,
            version: "weekly",
        });

        loader.load().then((google) => {
            social.maps.init($("#map-wrap"));
        });
    },
    maps: {

        elem: false,
        lat: false,
        lng: false,
        pin: false,
        zoom: 16,

        init: function (elem) {

            this.elem = elem;
            var self = this;
            var mapDiv = this.elem[0];

            if ($(mapDiv).data('zoom')) {
                self.zoom = parseInt($(mapDiv).data('zoom'));
            }

            if ($(mapDiv).data('pin')) {
                self.pin = $(mapDiv).data('pin');
            }

            var map = new google.maps.Map(mapDiv, {
                center: { lat: $(mapDiv).data('lat'), lng: $(mapDiv).data('lng') },
                zoom: self.zoom,
                disableDefaultUI: false,
                scrollwheel: false,
                draggable: true,
                styles: [{ "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#e9e9e9" }, { "lightness": 17 }] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 20 }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }, { "lightness": 17 }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 18 }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 16 }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 21 }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#dedede" }, { "lightness": 21 }] }, { "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 }] }, { "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 }] }, { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#f2f2f2" }, { "lightness": 19 }] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#fefefe" }, { "lightness": 20 }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 }] }]
            });

            map.markers = [];

            var center = new google.maps.LatLng($(mapDiv).data('lat'), $(mapDiv).data('lng'));
            var marker_options = {
                position: center,
                map: map,
                animation: google.maps.Animation.DROP
            }
            if (self.pin) {
                marker_options.icon = self.pin;
            }
            var marker = new google.maps.Marker(marker_options);
            map.markers.push(marker);
        },

    },
}

export default social;